import {OrderDto} from '../types'

import {OrderCancellationContextProvider} from './context'

export type OrderCancellationProcessProviderProps = React.PropsWithChildren & {
  order: OrderDto
  /**
   * Timer threshold duration in ISO 8601 format (e.g., '04:00:00' for 4 hours).
   * Defines when the cancellation countdown timer should activate before the deadline.
   * - If undefined: No timer shown, only cancellation status tracked
   * - If '00:00:00': Timer always shown when order is cancellable
   * - If duration: Timer activates when within this duration before cancellableUntil
   */
  cancellationTimerThreshold?: string
}

export const OrderCancellationProcessProvider: React.FC<OrderCancellationProcessProviderProps> = ({
  children,
  order,
  cancellationTimerThreshold
}) => {
  return (
    <OrderCancellationContextProvider order={order} timerThreshold={cancellationTimerThreshold}>
      {children}
    </OrderCancellationContextProvider>
  )
}
